import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import {
  FaHome,
  FaListAlt,
  FaUserAlt,
  FaDownload,
} from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import {
  clearSeachProductData,
  SearchProduct,
} from "../../redux/slices/SearchProductSlice";
import { fetchProducts } from "../../redux/slices/AllProductSlice";

function NavbarScreen() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileHovered, setIsProfileHovered] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("/");
  const [activeMenu, setActiveMenu] = useState("/");
  const [mobileSearchActive, setMobileSearchActive] = useState(false);

  // useEffect(() => {
  //   let LoginData = localStorage.getItem("authToken");
  //   if (LoginData) {
  //     localStorage.removeItem("uuid");
  //   }
  //   setUser(LoginData);
  // }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query.trim() === "") {
      dispatch(clearSeachProductData());
      dispatch(fetchProducts());
    } else {
      dispatch(SearchProduct(query));
    }
  };

  const toggleMobileMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIsProfileHovered(false);
  };

  const handleProfileClick = () => {
    setIsProfileHovered((prevState) => !prevState);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 768) {
        if (window.scrollY > lastScrollY) {
          setIsHeaderVisible(false);
        } else {
          setIsHeaderVisible(true);
        }
      }
      setLastScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    let storedUuid = localStorage.getItem("uuid");
    if (!storedUuid) {
      storedUuid = uuidv4();
      localStorage.setItem("uuid", storedUuid);
    }
    alert("You have been logged out successfully!");
    navigate("/my-account/");
    window.location.reload();
  };

  const handleSetActiveMenu = (menu) => {
    setActiveMenu(menu);
    toggleMobileMenu();
  };

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  if (mobileSearchActive) {
    return (
      <header className="fixed top-0 left-0 w-full z-50 bg-white p-3 flex items-center">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search..."
          className="w-full border-2 border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-200"
        />
        <button
          onClick={() => {
            dispatch(clearSeachProductData());
            dispatch(fetchProducts());
            setSearchQuery("");
            setMobileSearchActive(false);
          }}
          className="ml-2 focus:outline-none"
        >
          <IoClose size="24px" className="text-gray-500" />
        </button>
      </header>
    );
  }

  return (
    <header
      className={`navbar flex items-center justify-between p-3 sm:p-5 w-full z-50 bg-white transition-transform duration-300 ${isHeaderVisible ? "sticky top-0" : "absolute -translate-y-full"
        }`}
    >
      <div className="flex items-center h-2 sm:mb-0 mb-[-7%]">
        <a href="/" className="block">
          <img
            className="w-20 h-auto object-contain"
            src={require("../../assets/Logo.png")}
            alt="Logo"
          />
        </a>
      </div>

      <div className="w-full md:w-[40%] h-10 relative">
        <div className="absolute top-1/2 transform -translate-y-1/2 flex items-center justify-center h-9 w-10 like-btn sm:right-8 right-10 px-2 rounded-lg">
          <button
            onClick={() => {
              window.location.href = "/cart";
            }}
            className="block sm:hidden ml-10"
          >
            <FiShoppingCart
              size="20px"
              className="font-bold sm:text-base md:text-xl lg:text-2xl text-black"
            />
          </button>
          <div className="md:hidden flex items-center ml-5">
            <button
              onClick={toggleMobileMenu}
              className="text-black focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <nav className="flex items-center justify-evenly md:justify-end space-x-8 md:flex md:space-x-10">
        <ul className="hidden md:flex items-center space-x-8 text-black">
          <li>
            <Link
              to="/"
              className={`${activeTab === "/" ? "text-red-500" : "text-black"
                } hover:text-red-500 transition duration-300 ease-in-out flex items-center  no-underline`}
              onClick={() => {
                setActiveTab("/");
                if (activeTab === "/") {
                  window.location.reload();
                }
              }}
            >
              <FaHome
                color={activeTab === "/" ? "red" : "#808080"}
                className="mr-2 sm:mb-[5%] mb-0"
                size="20px"
              />
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/AllProductData"
              className={`${activeTab === "/AllProductData" ? "text-red-500" : "text-black"
                } hover:text-red-500 transition duration-300 ease-in-out flex items-center whitespace-nowrap  no-underline`}
              onClick={() => setActiveTab("/AllProductData")}
            >
              <FaListAlt
                color={activeTab === "/AllProductData" ? "red" : "#808080"}
                className="mr-2"
                size="20px"
              />
              All Products
            </Link>
          </li>
          <li>
            <div className="flex flex-row items-center space-x-2">
              <Link
                to="/cart"
                className={`${activeTab === "/cart" ? "text-red-500" : "text-black"
                  } relative flex items-center hover:text-red-500 transition duration-300 ease-in-out whitespace-nowrap  no-underline`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("/cart");
                  navigate("/cart");
                  window.location.reload();
                }}
              >
                <FiShoppingCart
                  color={activeTab === "/cart" ? "red" : "#808080"}
                  size="24px"
                />
                <span className="ml-2">Cart</span>
              </Link>
            </div>
          </li>
          <li className="relative">
            <div
              className="flex items-center cursor-pointer"
              onClick={handleProfileClick}
            >
              <FaUserAlt className="mr-2" size="20px" color="#808080" />
              Profile
            </div>

            {isProfileHovered && (
              <div
                className="absolute left-0 mt-2 bg-gray-200 shadow-lg rounded-lg w-48 z-10 overflow-hidden"
                style={{ transition: "all 0.3s ease-in-out" }}
              >
                <ul className="space-y-2 p-2">
                  <li
                    className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200"
                    onClick={() => {
                      handleSetActiveMenu("/Profile");
                      setIsProfileHovered(false);
                    }}
                  >
                    <Link
                      to={user ? "/Profile" : "/my-account/"}
                      className="hover:text-red-500 transition duration-300 ease-in-out  no-underline"
                    >
                      👤 My Profile
                    </Link>
                  </li>
                  <li className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200">
                    <Link
                      to="/track-your-order/"
                      className="hover:text-red-500 transition duration-300 ease-in-out  no-underline"
                      onClick={() => setIsProfileHovered(false)}
                    >
                      🚚 Track Orders
                    </Link>
                  </li>
                  <li className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200">
                    <Link
                      to="/offers"
                      className="hover:text-red-500 transition duration-300 ease-in-out  no-underline"
                      onClick={() => setIsProfileHovered(false)}
                    >
                      🎁 Offers
                    </Link>
                  </li>
                  {/* <li className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200">
                    <Link
                      to="/Wishlist"
                      className="hover:text-red-500 transition duration-300 ease-in-out"
                      onClick={() => setIsProfileHovered(false)}
                    >
                      🛍️ Wishlist
                    </Link>
                  </li> */}

                  {user && (
                    <li
                      className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200"
                      onClick={() => {
                        handleLogout();
                        setIsProfileHovered(false);
                      }}
                    >
                      Logout
                    </li>
                  )}
                </ul>
              </div>
            )}
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.bharatcod&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center whitespace-nowrap bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-3 py-2 rounded-md shadow-md hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 font-semibold"
            >
              <FaDownload className="mr-2" size="18px" />
              Download App
            </a>
          </li>
        </ul>
      </nav>

      {isMenuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white md:hidden p-4 z-50">
          <ul className="space-y-4 text-black">
            <li>
              <Link
                to="/"
                onClick={() => {
                  setActiveTab("/");
                  handleSetActiveMenu("/");
                  if (activeTab === "/") {
                    window.location.reload();
                  }
                }}
                className={`${activeMenu === "/" ? "text-red-900" : "text-black"
                  } hover:text-red-900 transition duration-300 ease-in-out`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/AllProductData"
                onClick={() => handleSetActiveMenu("/AllProductData")}
                className={`${activeMenu === "/AllProductData"
                  ? "text-red-900"
                  : "text-black"
                  } hover:text-red-900 transition duration-300 ease-in-out`}
              >
                All Products
              </Link>
            </li>
            <li>
              <Link
                to="/cart"
                onClick={(e) => {
                  e.preventDefault();
                  handleSetActiveMenu("/cart");
                  window.location.href = "/cart";
                }}
                className={`${activeMenu === "/cart" ? "text-red-900" : "text-black"
                  } hover:text-red-900 transition duration-300 ease-in-out`}
              >
                Cart
              </Link>
            </li>
            <li className="relative" onClick={handleProfileClick}>
              <div
                className={`${activeMenu === "/Profile" ? "text-red-900" : "text-black"
                  } hover:text-red-900`}
              >
                Profile
              </div>
              {isProfileHovered && (
                <div
                  className="absolute left-0 mt-2 bg-gray-200 shadow-lg rounded-lg w-48 z-10 overflow-hidden"
                  style={{ transition: "all 0.3s ease-in-out" }}
                >
                  <ul className="space-y-2 p-2">
                    <li
                      className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200"
                      onClick={() => handleSetActiveMenu("/Profile")}
                    >
                      <Link
                        to={user ? "/Profile" : "/my-account/"}
                        className="hover:text-red-900 transition duration-300 ease-in-out"
                        onClick={() => {
                          handleSetActiveMenu(
                            user ? "/Profile" : "/my-account/"
                          );
                          toggleMobileMenu();
                        }}
                      >
                        My Profile
                      </Link>
                    </li>
                    <li className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200">
                      <Link
                        to="/track-your-order/"
                        className="hover:text-red-900 transition duration-300 ease-in-out"
                        onClick={() => {
                          setIsProfileHovered(false);
                          toggleMobileMenu();
                        }}
                      >
                        Track Orders
                      </Link>
                    </li>

                    {/* <li className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200">
                      <Link
                        to="/Wishlist"
                        className="hover:text-red-900 transition duration-300 ease-in-out"
                        onClick={() => {
                          setIsProfileHovered(false);
                          toggleMobileMenu();
                        }}
                      >
                        Wishlist
                      </Link>
                    </li> */}
                    <Link
                      to="/Coupons"
                      className="hover:text-red-500 transition duration-300 ease-in-out"
                      onClick={() => {
                        setIsProfileHovered(false);
                        toggleMobileMenu();
                      }}
                    >
                      <li className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200">
                        Coupon
                      </li>
                    </Link>

                    {user && (
                      <li
                        className="px-4 py-2 text-black hover:bg-gray-400 cursor-pointer transition duration-200"
                        onClick={() => {
                          handleLogout();
                          setIsProfileHovered(false);
                        }}
                      >
                        Logout
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </li>
            <li>
              <Link
                to="/about-us/"
                onClick={() => handleSetActiveMenu("/about-us/")}
                className={`${activeMenu === "/about-us/" ? "text-red-900" : "text-black"
                  } hover:text-red-900 transition duration-300 ease-in-out`}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us/"
                onClick={() => handleSetActiveMenu("/contact-us/")}
                className={`${activeMenu === "/contact-us/" ? "text-red-900" : "text-black"
                  } hover:text-red-900 transition duration-300 ease-in-out`}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default NavbarScreen;
